import { Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AmbassadorProfileContext } from "..";
import CountUp from "react-countup";
import { CompletionGraph } from "../../../../components/ProfileCard";
import { LabeledProgressBar } from "../../../../components/progressbar";
import FlexBox from "../../../../components/layouts/Flexbox";
import { APP_COLORS } from "../../../../enums";
import { getProfileCompletionPercentages } from "./utils";

function ProfileCompletion() {
  const { data } = useContext(AmbassadorProfileContext);
  const [percentageData, setPercentageData] = useState(
    getProfileCompletionPercentages(null)
  );
  const { totalPercentage, accountInfoPercentage, productListPercentage } =
    percentageData;

  useEffect(() => {
    const timer = setTimeout(() => {
      setPercentageData(getProfileCompletionPercentages(data));
    }, 100);
    return () => clearTimeout(timer);
  }, [data, data?.technologies]);

  return (
    <Stack gap={2}>
      <FlexBox alignItems="center">
        <CompletionGraph size={116} percentage={Math.round(totalPercentage)}>
          <Typography variant="xlarge-mono-bold" component="div">
            <CountUp duration={0.5} end={Math.round(totalPercentage)} />%
          </Typography>
          <Typography variant="xsmall-bold" textTransform={"uppercase"}>
            Completed
          </Typography>
        </CompletionGraph>
      </FlexBox>

      <Stack gap={1}>
        <LabeledProgressBar
          label="Confirm your account and profile information"
          value={accountInfoPercentage}
          filledColor={APP_COLORS.primaryDark}
          emptyColor={APP_COLORS.primaryLight}
        />
        <LabeledProgressBar
          label="add 3 or more product with detail"
          value={productListPercentage}
          filledColor={APP_COLORS.secondaryDark}
          emptyColor={APP_COLORS.secondaryLight}
        />
      </Stack>
    </Stack>
  );
}

export default ProfileCompletion;
